var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 101,
    viewBox: "0 0 272 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 271,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.226 42.4893V55.0831L173.706 41.3805V58.5574H175.472V45.9597L188 59.6662V42.4893H186.226Z",
    fill: "#D9DBE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.838 42.4893H133.135V44.2167H118.838V42.4893Z",
    fill: "#D9DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.523 47.2669H125.277V58.5457H123.523V47.2669Z",
    fill: "#D9DBE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.446 47.2669H126.692V58.5457H128.446V47.2669Z",
    fill: "#D9DBE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.676 58.5574H176.906V49.8269L178.676 51.7644V58.5574Z",
    fill: "#D9DBE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.245 49.3601C161.597 49.3601 161.071 49.8775 161.071 50.5156C161.071 51.1536 161.597 51.6711 162.245 51.6711C162.893 51.6711 163.418 51.1536 163.418 50.5156C163.418 49.8775 162.893 49.3601 162.245 49.3601Z",
    fill: "#D9DBE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.086 50.5156C154.086 46.0842 157.745 42.4816 162.245 42.4816C166.745 42.4816 170.403 46.0881 170.403 50.5156C170.403 54.9469 166.745 58.5496 162.245 58.5496C157.745 58.5496 154.086 54.9469 154.086 50.5156ZM155.845 50.5156C155.845 53.9937 158.717 56.8183 162.245 56.8183C165.773 56.8183 168.645 53.9898 168.645 50.5156C168.645 47.0374 165.773 44.2129 162.245 44.2129C158.713 44.2129 155.845 47.0374 155.845 50.5156Z",
    fill: "#D9DBE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.051 42.4932C148.788 42.4932 151.017 44.7031 151.017 47.4187C151.017 49.5274 149.61 51.4415 147.599 52.099L151.08 58.5574H149.053L145.719 52.3441H141.638V58.5612H139.895V50.6012L146.086 50.605C147.828 50.5856 149.239 49.1655 149.239 47.4187C149.239 45.664 147.809 44.2362 146.051 44.2362H138.461V58.5612H136.719V42.4932H146.051Z",
    fill: "#D9DBE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.776 39.3069L83 35L95.5121 66L112.943 45.0843L106.776 39.3069ZM106.397 41.2054L110.035 44.6097L100.087 46.3838L106.397 41.2054ZM97.9261 46.0297L87.4407 37.4666L104.575 40.5713L97.9261 46.0297ZM97.1754 47.5471L95.4687 61.4636L86.2515 38.6182L97.1754 47.5471ZM98.7557 48.2824L109.771 46.3176L97.1399 61.4753L98.7557 48.2824Z",
    fill: "#FF060A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/Tron.777f329159fe64868916ed43da963577.svg";
export { ForwardRef as ReactComponent };